// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3bFh2","legacyBtn":"MutateMid_legacyBtn__1yRfG"};